import { Toggle } from "../../../components/Toggle";
import { useEffect, useState } from "react";

interface IActiveToggleProps {
  disabled: boolean;
  initialValue: boolean;
  onLabel: string;
  offLabel: string;
  onToggle: (val: boolean) => Promise<void>;
}

export const ActiveToggle = ({
  disabled,
  initialValue,
  onLabel,
  offLabel,
  onToggle
}: IActiveToggleProps) => {
  const [isToggled, setIsToggled] = useState<boolean>(null);
  const labelWidthCh = Math.max(onLabel.length, offLabel.length);

  useEffect(() => {
    setIsToggled(initialValue);
  }, [initialValue]);

  return (
    <div className="flex items-center h-full py-2">
      <Toggle
        checked={isToggled}
        onChange={async () => {
          setIsToggled((prev) => !prev);
          onToggle(!isToggled);
        }}
        disabled={disabled}
      />
      <span
        className="font-bold ml-4 text-sm inline-block"
        style={{ width: `${labelWidthCh}ch` }}
      >
        {isToggled ? onLabel : offLabel}
      </span>
    </div>
  );
};
